import { Tooltip, TooltipProps } from '@saucelabs/ds-tooltip';
import React from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { KeyContexts } from '../../global/KeyShortcuts';

type Props = {
  char: string | string[];
  displayChar?: string;
  label: string;
  func: () => void
  delay?: number;
  disabled?: boolean;
  scopes?: KeyContexts
  children: TooltipProps['children'];
  placement?: TooltipProps['placement'];
}

const KeyBind: React.FC<Props> = ({
  char,
  displayChar,
  label,
  func,
  delay,
  disabled = false,
  scopes = KeyContexts.GLOBAL,
  children,
  placement = 'top',
}) => {
  useHotkeys(char, () => (disabled ? null : func()), {
    scopes,
    combinationKey: '|',
  }, [char, func, disabled]);

  const charLabel = (displayChar ?? (
    Array.isArray(char) ? char.join(' + ') : char
  )).toUpperCase();

  return (
    <Tooltip
      delay={delay}
      isOpen={disabled ? false : undefined}
      placement={placement}
      title={(
        <>
          {label}
          <span className="bg-gray-700 px-0.5 rounded ml-1 text-gray-50 min-w-2.5 inline-block text-center">{charLabel}</span>
        </>
      )}
    >
      {children}
    </Tooltip>
  );
};

export default KeyBind;
